import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { getBlogsForSlug } from "@/lib/service-blogs";

interface Props { slug: string; eyebrow: string; }

const ServiceBlogs = ({ slug, eyebrow }: Props) => {
  const items = getBlogsForSlug(slug);
  if (!items.length) return null;

  return (
    <section className="py-14 md:py-20">
      <div className="container">
        <div className="text-center mb-10">
          <span className="text-eyebrow text-primary">From the Blog</span>
          <h2 className="font-heading text-2xl md:text-3xl font-light mt-2">
            Read more on {eyebrow}
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((post, i) => (
            <Card
              key={post.slug}
              className={i === 0 ? "lg:col-span-2 lg:row-span-1" : ""}
            >
              <CardContent className="p-0">
                <div className="h-32 bg-gradient-to-br from-primary/10 via-accent to-secondary/10 rounded-t-lg flex items-center justify-center">
                  <BookOpen className="h-8 w-8 text-primary/50" />
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-semibold text-base md:text-lg mb-2 leading-snug">
                    {post.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-3 leading-relaxed">{post.excerpt}</p>
                  <Link
                    to="/blogs"
                    className="text-sm font-medium text-primary inline-flex items-center gap-1 hover:underline"
                  >
                    Read more <ArrowRight className="h-3 w-3" />
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/blogs" className="inline-flex items-center gap-1 text-sm font-heading text-primary hover:underline">
            Visit the full blog <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceBlogs;